import { Quote } from 'types/quote';
import i18n from '@tecma/i18n';

export const formatDate = (date: Date, numeric?: boolean, ignoreTimezone = true) => {
  const normalizedDate = ignoreTimezone ? new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())) : date;
  return new Intl.DateTimeFormat(i18n.language, {
    year: 'numeric',
    month: numeric ? 'numeric' : 'short',
    day: 'numeric',
  }).format(normalizedDate);
};

export const formatQuoteDates = (quotes: Quote[]) => {
  return quotes.map((quote) => ({
    ...quote,
    createdOn: formatDate(new Date(quote.createdOn), true, false),
    dateRange: {
      checkInDate: formatDate(new Date(quote.dateRange?.checkInDate || '')),
      checkOutDate: formatDate(new Date(quote.dateRange?.checkOutDate || '')),
    },
  }));
};
